export default "__VITE_ASSET__BEtppGQv__"